import Vue from 'vue';
import { rewards, roles } from '../config'

// 全局过滤器
Vue.filter('rewardNameFilter', (item) => {
    return rewards.find(r => r.id === item.itemid)['name']
})

Vue.filter('rewardIconFilter',(item)=>{
    return rewards.find(r=>r.id===item.itemid)['img']
})

Vue.filter('rewardRoleName',(item)=>{
    return roles.find(r=>r.id===item.roleid)['name']
})

Vue.filter('rewardRoleImg',(item)=>{
    return roles.find(r=>r.id===item.roleid)['img']
})

Vue.filter('rewardRoleDesc',(item)=>{
    return roles.find(r=>r.id===item.roleid)['desc']
})
